/* istanbul ignore file */
import React from 'react';
import useListCrud, { InputData } from './builder/useListCrud';
import useListDataLoading, { GetDataMethodType } from './builder/useListDataLoading';
import { ListProvider } from './ListContext';

export interface SimpleListProps {
  getDataMethod: GetDataMethodType;
  children: React.ReactElement;
  pageSize?: number;
  onRemove?: (params: StringOrNumber) => void;
}

const DEFAULT_PAGE_SIZE = 30;

const SimpleList = ({ getDataMethod, children, pageSize = DEFAULT_PAGE_SIZE, onRemove }: SimpleListProps) => {
  const { loading, data, setLoading } = useListDataLoading({ getDataMethod, loadDataOnInit: true, pageSize });
  const listCrud = useListCrud({ onRemove, inputData: data as InputData });

  return (
    <ListProvider
      value={{
        ...listCrud,
        loading,
        setLoading,
      }}
    >
      {children}
    </ListProvider>
  );
};

export default SimpleList;
